import { Request } from 'api';
import { AxiosResponse } from 'axios';
import { Link } from 'utils';

type ReturnType = Promise<AxiosResponse<Array<Link>>>;

const getLinksForMovement = (id: string): ReturnType => {
    return Request.get(`/links/movement/${id}`);
};

export default getLinksForMovement;
